import { render, staticRenderFns } from "./CounterTabs.vue?vue&type=template&id=1f9abaf1&scoped=true"
import script from "./CounterTabs.vue?vue&type=script&lang=js"
export * from "./CounterTabs.vue?vue&type=script&lang=js"
import style0 from "./CounterTabs.vue?vue&type=style&index=0&id=1f9abaf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9abaf1",
  null
  
)

export default component.exports